/** @jsxImportSource @emotion/react */
import { useTheme } from '@emotion/react';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Box } from '@mui/material';
import IconButton from '@IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { handleClickBackward } from '../NavigationBar/navigationBar.helpers';
import makeStackedBackButtonStyles from './makeStackedBackButtonStyles';
import useShouldShowNavigation from '../../Hooks/useShouldShowNavigation/useShouldShowNavigation';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const StackedBackButton = () => {
  const dispatch = useDispatch();
  const {
    currentPage,
    totalPages,
    isLoading,
    isFirstVisiblePostSubmissionPage,
  } = useSelector((i) => i.navigation);

  const { pendingMoveForwards, blockedDestinationPage } = useSelector(
    (store) => store.navigationControls
  );
  const {
    isDynamicHeightEnabled,
    minimumWidgetHeight,
    maximumWidgetHeight,
    isConsentStatementAboveNavigation:
      isConsentStatementAboveNavigationFormConfig,
  } = useSelector((store) => store.optionalFormConfig);
  const {
    requiresLegalStatementAboveNav:
      supplierMatchesRequireLegalStatementAboveNav,
  } = useSelector((store) => store.supplierMatches);
  const { hasStatementGraduallyDisappeared, statement } = useSelector(
    (store) => store.legalStatement
  );
  const { submissionPageNumber } = useSelector((store) => store.formConfig);

  const stackedBackButtonExperimentName = useGetExperimentName({
    componentName: 'StackedBackButton',
  });

  const { shouldShowNavigation } = useShouldShowNavigation();
  const theme = useTheme();
  const styling = makeStackedBackButtonStyles(theme);

  const isPenultimatePage =
    typeof submissionPageNumber === 'number'
      ? currentPage === submissionPageNumber
      : currentPage + 1 === totalPages;

  const isConsentStatementAboveNavigation =
    isConsentStatementAboveNavigationFormConfig ||
    supplierMatchesRequireLegalStatementAboveNav;

  const shouldShowBackButton =
    currentPage !== 0 &&
    !isFirstVisiblePostSubmissionPage &&
    shouldShowNavigation;

  if (!shouldShowBackButton) {
    return null;
  }

  return (
    <Box css={styling.box}>
      <IconButton
        icon={<KeyboardArrowLeft />}
        variant="stacked"
        onClick={() => {
          handleClickBackward({
            dispatch,
            isDynamicHeightEnabled,
            isConsentStatementAboveNavigation,
            pendingMoveForwards,
            blockedDestinationPage,
            isLoading,
            isPenultimatePage,
            hasStatementGraduallyDisappeared,
            minimumWidgetHeight,
            maximumWidgetHeight,
            statement,
          });
        }}
        dataTestId="stackedBackCTA"
        experimentName={stackedBackButtonExperimentName}
      />
    </Box>
  );
};

export default StackedBackButton;
